import NotFound from "../components/Error/NotFound/404.jsx";
import redirect from "../utils/redirect.jsx";

const notFoundRoute = {
  path: "*",
  component: <NotFound />,
};

export default notFoundRoute;
